import KakaoTalkButton from '@/components/feature/KakaoTalkButton';

export default function ContactFooter() {
  return (
    <>
      {/* Contact Section */}
      <section className="w-full bg-white py-16 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row gap-10 items-stretch">
            {/* Left: image */}
            <div className="w-full md:w-1/2 rounded-2xl overflow-hidden min-h-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20professional%20caregiver%20service%20team%20in%20green%20uniforms%20smiling%20warmly%20in%20bright%20modern%20office%2C%20trustworthy%20and%20professional%20atmosphere%2C%20clean%20white%20and%20green%20interior%2C%20photorealistic%2C%20high%20quality&width=700&height=420&seq=kccont1&orientation=landscape"
                alt="코리아케어러스 고객센터"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Right: info */}
            <div className="w-full md:w-1/2 flex flex-col justify-center">
              <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>CONTACT US</p>
              <h2 className="text-2xl font-bold text-gray-900 mb-1">코리아케어러스 고객센터</h2>
              <a
                href="tel:15668654"
                className="text-4xl md:text-5xl font-bold mb-1 cursor-pointer transition-colors hover:opacity-80 block"
                style={{ color: '#2E7D6B' }}
              >
                1566-8654
              </a>
              <p className="text-sm text-gray-400 mb-1">FAX. 070-7862-8654</p>
              <p className="text-sm text-gray-400 mb-6">
                <a href="mailto:support@koreacarers.com" className="hover:opacity-70 transition-opacity">support@koreacarers.com</a>
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#f4faf8' }}>
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: '#e8f5f1' }}>
                    <i className="ri-time-line text-sm" style={{ color: '#2E7D6B' }}></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-700 mb-0.5">상담시간</p>
                    <p className="text-xs text-gray-500">오전 9시 ~ 오후 11시<br />연중무휴</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#f4faf8' }}>
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: '#e8f5f1' }}>
                    <i className="ri-map-pin-2-line text-sm" style={{ color: '#2E7D6B' }}></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-700 mb-0.5">주소</p>
                    <p className="text-xs text-gray-500">전북특별자치도 전주시<br />덕진구 사평로 33, 2층</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-3">
                <a
                  href="/register"
                  className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
                  style={{ backgroundColor: '#2E7D6B' }}
                >
                  <i className="ri-user-add-line mr-1.5"></i>가족간병 등록
                </a>
                <a
                  href="/caregiver-job"
                  className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
                  style={{ backgroundColor: '#EA8C00' }}
                >
                  <i className="ri-briefcase-line mr-1.5"></i>간병인 일자리
                </a>
                <a
                  href="tel:15668654"
                  className="px-5 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity border"
                  style={{ borderColor: '#2E7D6B', color: '#2E7D6B' }}
                >
                  <i className="ri-phone-line mr-1.5"></i>전화 상담
                </a>
                <KakaoTalkButton
                  className="px-5 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
                  style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
                  ariaLabel="카톡 상담"
                >
                  <i className="ri-kakao-talk-fill mr-1.5"></i>카톡 상담
                </KakaoTalkButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-12" style={{ backgroundColor: '#0d2b24' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between gap-10 mb-10">
            {/* Brand */}
            <div className="flex-shrink-0 max-w-xs">
              <img
                src="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/cba37159-d3f8-46db-9763-695cb2aae33c_unnamed.png?v=a72b44c5f622d80e8ffedcfaa4987858"
                alt="코리아케어러스 로고"
                className="h-12 w-auto object-contain mb-4"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <p className="text-xs leading-relaxed" style={{ color: 'rgba(255,255,255,0.4)' }}>
                가족간병 등록부터 보험 청구 서류까지<br />도와드리는 전문 간병 서비스
              </p>
            </div>

            {/* Links */}
            <div className="flex gap-12 flex-wrap">
              <div>
                <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: 'rgba(255,255,255,0.5)' }}>서비스</p>
                <ul className="space-y-2.5">
                  {[
                    { label: '가족간병 등록', href: '/register' },
                    { label: '간병비 청구절차', href: '/process' },
                    { label: '필요서류 안내', href: '/document' },
                    { label: '고객 후기', href: '/review' },
                  ].map((l) => (
                    <li key={l.label}>
                      <a href={l.href} className="text-xs cursor-pointer transition-colors" style={{ color: 'rgba(255,255,255,0.4)' }}
                        onMouseEnter={e => (e.currentTarget.style.color = '#6fcfb8')}
                        onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')}
                      >{l.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: 'rgba(255,255,255,0.5)' }}>고객지원</p>
                <ul className="space-y-2.5">
                  {[
                    { label: '자주 묻는 질문', href: '/faq' },
                    { label: '이용약관', href: '/terms' },
                    { label: '개인정보처리방침', href: '/privacy' },
                  ].map((l) => (
                    <li key={l.label}>
                      <a href={l.href} className="text-xs cursor-pointer transition-colors" style={{ color: 'rgba(255,255,255,0.4)' }}
                        onMouseEnter={e => (e.currentTarget.style.color = '#6fcfb8')}
                        onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')}
                      >{l.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t pt-6 flex flex-col md:flex-row justify-between gap-3 items-start md:items-center" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
            <div className="text-xs leading-relaxed space-y-1" style={{ color: 'rgba(255,255,255,0.3)' }}>
              <p><strong style={{ color: 'rgba(255,255,255,0.5)' }}>코리아케어러스</strong> | 대표: 박종영 | 전북특별자치도 전주시 덕진구 사평로 33, 2층</p>
              <p>사업자등록번호: 461-95-02005 | 직업소개소 신고번호: 제 2026-4661006-14-5-00005 호</p>
              <p>대표번호: 1566-8654 | FAX: 070-7862-8654 | E-mail: support@koreacarers.com</p>
              <p className="pt-1">Copyright ⓒ 2026 코리아케어러스 All rights reserved.</p>
            </div>
            <div className="flex gap-2">
              {['ri-instagram-line', 'ri-article-line', 'ri-youtube-line'].map((icon) => (
                <a key={icon} href="#" className="w-8 h-8 flex items-center justify-center rounded-xl border cursor-pointer transition-all"
                  style={{ borderColor: 'rgba(255,255,255,0.15)' }}
                  onMouseEnter={e => (e.currentTarget.style.borderColor = '#2E7D6B')}
                  onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)')}
                >
                  <i className={`${icon} text-sm`} style={{ color: 'rgba(255,255,255,0.4)' }}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Buttons */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        <KakaoTalkButton
          className="w-14 h-14 flex items-center justify-center rounded-full cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#FEE500' }}
          ariaLabel="카톡 상담"
        >
          <i className="ri-kakao-talk-fill text-2xl" style={{ color: '#391B1B' }}></i>
        </KakaoTalkButton>
        <a
          href="tel:15668654"
          className="w-14 h-14 flex items-center justify-center rounded-full cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#2E7D6B' }}
          aria-label="전화 상담"
        >
          <i className="ri-phone-line text-white text-xl"></i>
        </a>
      </div>
    </>
  );
}